module.exports = __webpack_public_path__ + "public/media/asap.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/asap.png
// module id = ./images/partners/asap.png
// module chunks = 0